export default [
  {
    path: '/report',
    name: 'report',
    redirect: '/report/healthReport',
    meta: {
      title: '报告',
    },
    children: [
      {
        path: 'healthReport',
        name: 'healthReport',
        component: () => import('@/views/report/HealthReport.vue'),
        meta: {
          title: '健康报告',
        },
      },
    ],
  },
]
